const theme = {
  palette: {
    primary: {
      main: '#1565c0',
    },
    secondary: {
      main: '#DC3545',
    },
  },
  typography: {
    display1: {
      color: '#000000',
      fontWeight: 100,
    },
    title: {
      fontWeight: 300,
    },
  },
};

export default theme;



// WEBPACK FOOTER //
// ./src/styles/theme.js